var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfferErrorBadge = function SvgOfferErrorBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E14851",
    stroke: "#E14851",
    strokeWidth: 1.5,
    d: "M20.138 8.465 4.387 35.243a1 1 0 0 0 .861 1.507h31.504a1 1 0 0 0 .861-1.507L21.863 8.465a1 1 0 0 0-1.724 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M21 17.5V28"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 31.5,
    r: 1.75,
    fill: "#fff"
  })));
};
export { SvgOfferErrorBadge as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDIiIGhlaWdodD0iNDIiIHZpZXdCb3g9IjAgMCA0MiA0MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0yMC4xMzgxIDguNDY1MjlMNC4zODY1MSAzNS4yNDNDMy45OTQzOCAzNS45MDk2IDQuNDc1MDMgMzYuNzUgNS4yNDg0NSAzNi43NUgzNi43NTE2QzM3LjUyNSAzNi43NSAzOC4wMDU3IDM1LjkwOTYgMzcuNjEzNSAzNS4yNDNMMjEuODYyIDguNDY1MjlDMjEuNDc1MyA3LjgwNzk4IDIwLjUyNDcgNy44MDc5OCAyMC4xMzgxIDguNDY1MjlaIiBmaWxsPSIjRTE0ODUxIiBzdHJva2U9IiNFMTQ4NTEiIHN0cm9rZS13aWR0aD0iMS41Ii8+CiAgICA8cGF0aCBkPSJNMjEgMTcuNVYyOCIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgogICAgPGNpcmNsZSBjeD0iMjEiIGN5PSIzMS41IiByPSIxLjc1IiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";